module.exports = __webpack_public_path__ + "img/小程序点单.b704ee80.png";